module.exports = __webpack_public_path__ + "static/media/webdesign-services-img51.ae8f89f3.jpg";